export default __webpack_public_path__ + "static/media/bharath-b-k.43168610.jpg";